import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "../style/orderSuccess.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { routePaths } from "../constants/routes";
import { getLatestOrder } from "../services/orderService";

const OrderSuccess = () => {
  const [order, setOrder] = useState(null);

  useEffect(() => {
    setOrder(getLatestOrder());
  }, []);

  if (!order) {
    return (
      <div className="order-success-wrapper">
        <div className="order-success-card">
          <h1 className="success-title">No recent order found</h1>
          <p className="success-subtitle">Place an order first to view the invoice and success details.</p>
          <div className="success-actions">
            <NavLink to="/product" className="success-btn primary">
              Browse Products
            </NavLink>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="order-success-wrapper">
      <div className="order-success-card">
        <div className="success-icon-circle">
          <i className="fas fa-check"></i>
        </div>

        <h1 className="success-title">Order Placed Successfully!</h1>

        <p className="success-subtitle">
          Thank you for your purchase. Your order has been confirmed and the invoice has been generated.
        </p>

        <div className="success-status-strip">
          <span>Invoice ready</span>
          <span>{order.status}</span>
          <span>
            Expected delivery:{" "}
            {new Date(order.estimatedDeliveryDate).toLocaleDateString("en-IN", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })}
          </span>
        </div>

        <div className="invoice-box">
          <p>Your Invoice Number is:</p>
          <strong>{order.invoiceNumber}</strong>
          <p style={{ marginTop: "12px" }}>
            Total Paid: <strong>Rs.{order.total.toLocaleString("en-IN")}</strong>
          </p>
          <p>
            Payment Method: <strong>{order.paymentMethod}</strong>
          </p>
        </div>

        <div className="invoice-box order-items-box">
          <p>
            <strong>Items in this order</strong>
          </p>
          {order.items.map((item) => (
            <div key={item.id} className="success-item-row">
              <span>{item.name} x{item.quantity}</span>
              <strong>
                Rs.{(Number(item.price) * Number(item.quantity)).toLocaleString("en-IN")}
              </strong>
            </div>
          ))}
        </div>

        <div className="invoice-box">
          <p>
            <strong>Delivery Address</strong>
          </p>
          <p>
            {order.address.name}, {order.address.phone}
          </p>
          <p>
            {order.address.address1}
            {order.address.address2 ? `, ${order.address.address2}` : ""}
          </p>
          <p>
            {order.address.city}, {order.address.state} - {order.address.pincode}
          </p>
        </div>

        <div className="success-actions">
          <NavLink to={routePaths.orderHistory} className="success-btn primary">
            <i className="fas fa-list"></i> View Order History
          </NavLink>

          <NavLink to={routePaths.invoice(order.invoiceNumber)} className="success-btn primary">
            <i className="fas fa-file-invoice"></i> View Invoice
          </NavLink>

          <NavLink to={routePaths.orderTracking(order.invoiceNumber)} className="success-btn primary">
            <i className="fas fa-truck"></i> Track Order
          </NavLink>

          <NavLink to={routePaths.product} className="success-btn secondary">
            <i className="fas fa-home"></i> Continue Shopping
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;
